import { SalonStatusType } from "../enums/SalonStatusType";

export const isSalonAvailable = (
  salonStatus: SalonStatusType | undefined
): boolean => {
  switch (salonStatus) {
    case SalonStatusType.PendingApproval:
      return false;
    case SalonStatusType.Approved:
      return true;
    case SalonStatusType.PaymentDueSoon:
      return true;
    case SalonStatusType.PaymentOverdue:
      return true;
    case SalonStatusType.SuspendedForPayment:
      return false;
    case SalonStatusType.ManuallySuspended:
      return false;
    case SalonStatusType.PermanentlyClosed:
      return false;
    case SalonStatusType.UnderReview:
      return false;
    case SalonStatusType.Trial:
      return true;
    case SalonStatusType.Inactive:
      return false;
    default:
      return false;
  }
};
